import Render from '@Views/root/patients/context-main.html'
import { Component, Vue } from 'vue-property-decorator'

@Render
@Component({})
export class ContextMain extends Vue {}